<template>
  <div>
    <form>
      <div class="row">
        <div class="col-md-4 field">
          <label style="color: gray">Nome:</label>
          <BaseInput
            type="text"
            v-model="$v.partner.name.$model"
            :error="$v.partner.name.$error"
            :message="nameErrorMessages"
          />
        </div>

        <div class="col-md-4 field">
          <label style="color: gray">CNPJ:</label>
          <BaseInput
            type="text"
            v-model="$v.partner.cnpj.$model"
            :mask="['##.###.###/####-##']"
            :error="$v.partner.cnpj.$error"
            :message="cnpjErrorMessages"
          />
        </div>

        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Telefone:</label>
          <BaseInput
            type="text"
            v-model="$v.partner.phone_number.$model"
            :mask="['(##) ####-####', '(##) #####-####']"
            :error="$v.partner.phone_number.$error"
            :message="phoneNumberErrorMessages"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Produto em Promoção:</label>

          <BaseInput
            type="text"
            list="patient"
            v-model="partner.product_in_promotion"
          />
        </div>

        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Promoção do mês:</label>

          <BaseInput
            type="text"
            list="patient"
            v-model="partner.month_promotion"
          />
        </div>

        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Tipo de estabelecimento:</label>
          <BaseSelect
            :options="partnerTypeOptions"
            v-model="$v.partner.partner_type.$model"
            :error="$v.partner.partner_type.$error"
            :message="partnerTypeErrorMessages"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Rua:</label>
          <BaseInput
            v-mask="null"
            type="text"
            v-model="partner.address.street"
          />
        </div>
        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Bairro:</label>
          <BaseInput
            v-mask="null"
            type="text"
            v-model="partner.address.neighbourhood"
          />
        </div>
        <div class="col-md-2 mt-2 field">
          <label style="color: gray">Número:</label>
          <BaseInput
            v-mask="null"
            type="text"
            v-model="partner.address.number"
          />
        </div>
        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Cidade:</label>
          <BaseInput v-mask="null" type="text" v-model="partner.address.city" />
        </div>
        <div class="col-md-4 mt-2 field">
          <label style="color: gray">Estado:</label>
          <BaseInput
            v-mask="null"
            type="text"
            v-model="partner.address.state"
          />
        </div>
      </div>

      <br />
      <br />
      <br />

      <h4 align="center">Dados para contato</h4>

      <div class="row">
        <div class="col-md-6 field">
          <label style="color: gray">Nome:</label>
          <BaseInput
            type="text"
            v-model="$v.partner.representant_data.name.$model"
            :message="representantNameErrorMessages"
            :error="$v.partner.representant_data.name.$error"
          />
        </div>
        <div class="col-md-6 field">
          <label style="color: gray">Email:</label>
          <BaseInput
            type="text"
            v-model="$v.partner.representant_data.email.$model"
            :message="representantEmailErrorMessages"
            :error="$v.partner.representant_data.email.$error"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 field">
          <label style="color: gray">Telefone:</label>
          <BaseInput
            type="text"
            :mask="['(##) ####-####', '(##) #####-####']"
            v-model="$v.partner.representant_data.phone_number.$model"
            :message="representantPhoneNumberErrorMessages"
            :error="$v.partner.representant_data.phone_number.$error"
          />
        </div>
      </div>

      <div class="row">
        <button
          type="submit"
          class="button2 mt-4 offset-5"
          @click.prevent="showConfirmModal()"
        >
          Cadastrar
        </button>
      </div>
    </form>

    <BModal id="success" ref="success" hide-footer hide-header
centered
>
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Parceiro criado
        </h4>
      </div>
    </BModal>

    <BModal
      id="confirmModal"
      ref="confirmModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          {{ `${alertMessage}` }}
        </h4>
        <BButton class="button2 mb-2" block @click="createPartner()">
          Confirmar
        </BButton>

        <BButton class="button2 mb-2" block @click="hideConfirmModal()">
          Cancelar
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script>
import { userMethods } from "./../state/helpers";
import { required, email } from "vuelidate/lib/validators";
import { hasValidChars } from "../utils/validations/email";

export default {
  data() {
    return {
      alertMessage: "Confirma seus dados?",
      partner: {
        name: "",
        cnpj: "",
        phone_number: "",
        product_in_promotion: "",
        month_promotion: "",
        partner_type: "",
        representant_data: {
          name: "",
          email: "",
          phone_number: ""
        },
        address: {
          street: "",
          neighbourhood: "",
          number: "",
          state: "",
          city: ""
        }
      }
    };
  },

  validations: {
    partner: {
      name: { required },
      cnpj: { required },
      partner_type: { required },
      phone_number: {
        required,
        async isUnique(value) {
          let phone = value.replace(/[^0-9\.]+/g, "");
          if (value.length >= 14) {
            await this.phoneNumberVerification({ phone_number: phone }).then(
              response => response.data.status
            );
          }
          return true;
        }
      },
      representant_data: {
        name: { required },
        email: {
          required,
          email,
          hasValidChars,
          async isUnique(value) {
            if (value.includes("@")) {
              await this.emailVerification({ email: value }).then(response => {
                return response.data.status;
              });
            }
            return true;
          }
        },
        phone_number: {
          required,
          async isUnique(value) {
            let phone = value.replace(/[^0-9\.]+/g, "");
            if (value.length >= 14) {
              await this.phoneNumberVerification({ phone_number: phone }).then(
                response => response.data.status
              );
            }
            return true;
          }
        }
      }
    }
  },

  methods: {
    ...userMethods,

    hideConfirmModal() {
      this.$bvModal.hide("confirmModal");
    },
    showSuccessModal() {
      this.$bvModal.show("success");
    },
    hideSuccessModal() {
      this.$bvModal.hide("success");
    },

    showConfirmModal() {
      this.$v.$touch();
      if (this.isPartnerFormValid) {
        this.$bvModal.show("confirmModal");
      }
    },

    buildAddress() {
      let address = this.partner.address;
      let street = address.street ? address.street + ", " : "";
      let number = address.number ? address.number + ", " : "";
      let neighbourhood = address.neighbourhood
        ? address.neighbourhood + ", "
        : "";
      let city = address.city ? address.city + ", " : "";
      let state = address.state ? address.state : "";

      return `${street}${number}${neighbourhood}${city}${state}`;
    },

    partnerParams() {
      return {
        name: this.partner.name,
        cnpj: this.partner.cnpj.replace(
          /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g,
          ""
        ),
        phone_number: this.partner.phone_number.replace(/[^0-9\.]+/g, ""),
        product_in_promotion: this.partner.product_in_promotion,
        month_promotion: this.partner.month_promotion,
        partner_type: this.partner.partner_type,
        representant_data: {
          name: this.partner.representant_data.name,
          email: this.partner.representant_data.email,
          phone_number: this.partner.representant_data.phone_number
        },
        address: this.buildAddress()
      };
    },

    createPartner() {
      if (this.isPartnerFormValid) {
        this.$store
          .dispatch("partner/createPartner", this.partnerParams())
          .then(_ => {
            this.hideConfirmModal();
            this.showSuccessModal();
            setTimeout(() => {
              this.hideSuccessModal();
              window.location.reload();
            }, 2500);
          });
      }
    }
  },

  computed: {
    isPartnerFormValid() {
      return !this.$v.partner.$invalid;
    },

    partnerTypeOptions() {
      return [
        { label: "Laboratório", value: "laboratory" },
        { label: "Clínica", value: "clinic" },
        { label: "Farmácia", value: "pharmacy" }
      ];
    },

    nameErrorMessages() {
      let errors = [];
      !this.$v.partner.name.required && errors.push("Nome é obrigatório");
      return errors;
    },

    cnpjErrorMessages() {
      let errors = [];
      !this.$v.partner.cnpj.required && errors.push("CNPJ é obrigatório");
      return errors;
    },

    phoneNumberErrorMessages() {
      let errors = [];
      !this.$v.partner.phone_number.required &&
        errors.push("Número de telefone é obrigatório");
      !this.$v.partner.phone_number && errors.push("Telefone é inválido");
      !this.$v.partner.phone_number.isUnique &&
        errors.push("Este número de telefone já está sendo utilizado");
      return errors;
    },

    partnerTypeErrorMessages() {
      let errors = [];
      !this.$v.partner.partner_type.required &&
        errors.push("Estabelecimento é obrigatório");
      return errors;
    },

    representantNameErrorMessages() {
      let errors = [];
      !this.$v.partner.representant_data.name.required &&
        errors.push("Nome é obrigatório");
      return errors;
    },

    representantEmailErrorMessages() {
      let errors = [];
      !this.$v.partner.representant_data.email.required &&
        errors.push("Email é obrigatório");
      !this.$v.partner.representant_data.email &&
        errors.push("E-mail é inválido");
      !this.$v.partner.representant_data.email.isUnique &&
        errors.push("Este e-mail já está em uso");
      !this.$v.partner.representant_data.email.hasValidChars &&
        errors.push(
          "Somente letras de (a - z), números de (0 - 9),e pontos (.) são permitidos"
        );
      return errors;
    },

    representantPhoneNumberErrorMessages() {
      let errors = [];
      !this.$v.partner.representant_data.phone_number.required &&
        errors.push("Número de telefone é obrigatório");
      !this.$v.partner.representant_data.phone_number &&
        errors.push("Telefone é inválido");
      !this.$v.partner.representant_data.phone_number.isUnique &&
        errors.push("Este número de telefone já está sendo utilizado");
      return errors;
    }
  },

  watch: {}
};
</script>

<style></style>
